module.exports = __webpack_public_path__ + "product-compound-capsule-main-thumb-03.jpg?a396ad233b8e669f57db539ada90f7b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-main-thumb-03.jpg
// module id = 97
// module chunks = 0